import { React, useState, useRef, useEffect } from "react";
import { Button } from 'antd-mobile'
import styles from './TagFilter.module.css'

//props.listShell 传入的参数，一个来自states类的列表的包装
export default (props) => {
  if (!props.listShell) return null
  console.log("TagFilter.js默认渲染流程")
  const [_curULPos, setCurULPos] = useState(0)
  const [trig, setTrig] = useState(1)
  const ref_UL = useRef(null)

  useEffect(() => { //设置滚动条回滚
    if (ref_UL.current) {
      ref_UL.current.scrollTop = _curULPos
    }
  }, [trig])

  const onListItemClicked = (key) => {
    console.log('按了按钮！', key)
    if (ref_UL.current) {
      setCurULPos(ref_UL.current.scrollTop)
    }
    props.listShell.list[key].selected = !props.listShell.list[key].selected
    setTrig(trig + 1)
  }

  const RenderSingleListItem = (props) => {

    return (<div className={styles.tagListItem}>
      <Button style={{ marginBottom: '2px', marginRight: '5px' }} block shape="rounded" color="success"
        fill={props.tag.selected ? "solid" : "outline"}
        onClick={() => { onListItemClicked(props.tag.key) }}>{props.tag.name}</Button>
    </div>)
  }
  const onSelectAllClicked = (bAll) => {
    props.listShell.list.forEach((item) => {
      item.selected = bAll
    })
    if (ref_UL.current) {
      setCurULPos(ref_UL.current.scrollTop)
    }
    setTrig(trig + 1)
  }

  const RenderList = () => {
    console.log('渲染List，当前的数据是', props.listShell.list)
    return (<div className={styles.fltContainer}>
      <ul ref={ref_UL} trig={trig} className={styles.fltList}>
        {props.listShell.list.map((tag) => {
          return (
            <li key={tag.key}><RenderSingleListItem tag={tag} /></li>
          )
        })}
      </ul>
      <div style={{ width: '10%' }}></div>
      <div className={styles.fltBtn}>
        <Button block onClick={() => onSelectAllClicked(true)}>全选</Button>
        <div style={{ height: '20px' }} />
        <Button block onClick={() => onSelectAllClicked(false)}>不选</Button>
      </div>
    </div>)
  }

  return (<RenderList />) 
}